import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon1: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#F3123C"
        d="M14.335 8.703a4.321 4.321 0 0 0-.577-1.978L10.626 1.31A4.306 4.306 0 0 1 10.132 0l-.13.227A4.322 4.322 0 0 0 10 4.558l2.505 4.333a4.328 4.328 0 0 1 0 4.333l-.131.225a4.301 4.301 0 0 0-.495-1.308L9.585 8.174 8.12 5.641a4.303 4.303 0 0 1-.495-1.308l-.13.225a4.327 4.327 0 0 0-.008 4.319L10 13.224a4.334 4.334 0 0 1 0 4.333l-.133.226a4.287 4.287 0 0 0-.494-1.31l-3.132-5.416a4.335 4.335 0 0 1-.577-2.354C2.314 9.578 0 11.435 0 13.585 0 16.575 4.476 19 10.001 19 15.524 19 20 16.575 20 13.585c0-2.15-2.314-4.009-5.665-4.882Z"
      />
    </Svg>
  )
}
